function normalizeResponse(response) {
    return response.json();
}

function httpRequest(method, url, params, authToken) {
    //alert ("fetch " + url);
    const config = {
        method,
        headers: {},
    };
    if (params) {
        config.body = JSON.stringify(params);
    }
    if (["POST", "DELETE", "PUT"].indexOf(method.toUpperCase()) !== -1) {
        config.headers["Content-Type"] = "application/json;charset=utf-8";
    }
    if (authToken) {
        config.headers.Authorization = authToken;
        config.headers["Api-Token"] = authToken;
    }

    return fetch(`${url}`, config)
        .then(normalizeResponse)
        .catch((response) => {
            if (
                response.headers &&
                response.headers.get("Content-Type").indexOf("application/json") === 0
            ) {
                return response.json().then((r) => Promise.reject(r));
            }
            return Promise.reject(response);
        });
}


function rawFetch(url, formData) {
    return fetch(`${url}`, {
        method: 'POST',
        body: formData})
        .then(normalizeResponse)
        .catch((response) => {
            if (
                response.headers &&
                response.headers.get("Content-Type").indexOf("application/json") === 0
            ) {
                return response.json().then((r) => Promise.reject(r));
            }
            return Promise.reject(response);
        });
}

export default class API {
    static get(url, authToken) {
        return httpRequest("GET", url, null, authToken);
    }
    static put(url, params, authToken) {
        return httpRequest("PUT", url, params, authToken);
    }
    static post(url, params, authToken) {
        return httpRequest("POST", url, params, authToken);
    }
    static delete(url, authToken) {
        return httpRequest("DELETE", url, null, authToken);
    }
    static patch(url, params) {
        return httpRequest("PATCH", url, params);
    }
    static formPost(url, body) {
        return rawFetch(url, body);
    }
}
